import React, { useState } from "react";
import DTOFnfARModal from "./DTOFnfARModal";
import FnfARModalPresenter from "./FnfARModalPresenter";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../infra/hooks";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";
import toast from "react-hot-toast";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  fullData?: any;
}

const FnfARModalController = ({
  isModalOpen,
  closeModal,
  fullData,
}: ModalInterface) => {
  const [allActions, setAllActions] = useState([]);
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state.authSlice);

  const getActions = (act: any) => {
    setAllActions(act);
  };
  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };

  return (
    <div>
      <DTOFnfARModal setAllActions={getActions} />

      <FnfARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        fullData={fullData}
        allActions={allActions}
        userId={selector.user_id}
        handleSubmitAR_Request={hitAction}
      />
    </div>
  );
};

export default FnfARModalController;
